import { post, get, put } from '../utils/api';
import { DataResponse } from './response';

export type TestTarget = {
  stt: number;
  testTargetId: string;
  targetCode: number | null;
  targetName: string;
  stepCode: string;
  stepName: string;
  actived: boolean | null;
  // sai so cho phep
  tolerance: string;
  // chi tieu dinh luong
  isQualityIndiCation: boolean | null;
  // bat buoc kiem tra theo lenh
  requiredByWO: boolean | null;
  // bat buoc kiem tra theo the treo
  requiredByWOCard: boolean | null;
  // tieu chuan kiem tra
  standard: string;
};

export type TestTargetDetail = Partial<
  Pick<
    TestTarget,
    | 'targetName'
    | 'stepCode'
    | 'stepName'
    | 'actived'
    | 'targetCode'
    | 'tolerance'
    | 'isQualityIndiCation'
    | 'requiredByWO'
    | 'requiredByWOCard'
    | 'standard'
  >
>;

// Patial : bien prop thanh optional (?:)
// Pick lay prop cua 1 type khac
export type AddTestTarget = {
  targetName?: string;
  stepCode?: string;
  // sai so cho phep
  tolerance?: string;
  // chi tieu dinh luong
  isQualityIndiCation?: boolean | null;
  requiredByWO?: boolean | null;
  requiredByWOCard?: boolean | null;
  standard?: string;
};

export type EditTestTarget = {
  targetName?: string;
  stepCode?: string;
  actived?: boolean | null;
  testTargetId?: string;
  // sai so cho phep
  tolerance?: string;
  // chi tieu dinh luong
  isQualityIndiCation?: boolean | null;
  requiredByWO?: boolean | null;
  requiredByWOCard?: boolean | null;
  standard?: string;
};

export type TestTargetResponse = {
  data: Array<TestTarget>;
  message: string;
  isSuccess: boolean;
  //tong so phan tu trong mang
  recordsTotal: number;
  //so ket qua trong 1 trang
  resultsCount: number;
  //so trang
  pagesCount: number;
};

// interface cua Test Target
// khoi tao cac phuong thuc

export interface ITestTargetServices {
  getList(data: any): Promise<TestTargetResponse>;
  createTestTarget(data: AddTestTarget): Promise<DataResponse<object>>;
  updateTestTarget(data: EditTestTarget): Promise<DataResponse<TestTarget>>;
  getTestTargetById(id: string): Promise<DataResponse<TestTarget>>;
}

//ham khoi tao cac phuong thuc cua Test Target
export function createTestTargetServices(): ITestTargetServices {
  return {
    getList: async (data: any): Promise<TestTargetResponse> => {
      return (await post(`MasterData/TestTarget/list-testTarget`, data)).data;
    },
    createTestTarget: async (
      data: AddTestTarget
    ): Promise<DataResponse<object>> => {
      return (await post(`MasterData/TestTarget/CreateTestTarget`, data)).data;
    },
    updateTestTarget: async (
      data: EditTestTarget
    ): Promise<DataResponse<TestTarget>> => {
      return (await put(`MasterData/TestTarget/UpdateTestTarget`, data)).data;
    },
    getTestTargetById: async (
      id: string
    ): Promise<DataResponse<TestTarget>> => {
      return (
        await get(`MasterData/TestTarget/GetTestTargetById?testTargetId=${id}`)
      ).data;
    },
  };
}
